import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { sendFacebookEvent } from '@/utils/facebookServerUtils';

import { initializeStore } from '@/redux/initialize-store';
import { StoreConfModel } from '@/models';
import { UntypedObject, valueof } from '@/types';
import { getBlogServerSideProps } from '@/utils/blogUtils';

import BlogLayout from '@/components/blog/pages/BlogLayout';
import BlogComponent from '@/components/blog/pages/BlogComponent';
import { BLOG_PAGE_TYPE } from '@/constants/blog';

type BlogSlugProps = {
  data: UntypedObject;
  componentType: valueof<typeof BLOG_PAGE_TYPE>
  slug: string;
  storeConf: StoreConfModel
}

export const BlogSlug = ({ data, componentType, slug, storeConf }: BlogSlugProps) => {
  return (
    <BlogLayout storeConf={storeConf} data={data} componentType={componentType} slug={slug}>
      <BlogComponent data={data} componentType={componentType} />
    </BlogLayout>
  );
};

export default BlogSlug;

export const getServerSideProps = (async (ctx) => {
  const store = initializeStore({ ssrContext: ctx });
  return getBlogServerSideProps(ctx, store, serverSideTranslations, sendFacebookEvent);
});
